const Mixes = () => (
  <h1>Mixes</h1>
);

export default Mixes;
